var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "qrcode",
    attrs: {
      "title": $t("ek8q4b4", "点击刷新")
    }
  }, [_vm.stale && _vm.SCAN_EWM ? _c('div', {
    staticClass: "not",
    on: {
      "click": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', [_c('Icon', {
    attrs: {
      "type": "ios-alert",
      "size": "60",
      "color": "#ffd77a"
    }
  })], 1), _c('div', [_vm._v($t("lzvzl49", "二维码已过期 刷新"))])])]) : _vm._e(), _vm.SCAN_EWM ? _c('canvas', {
    staticClass: "qrcode_canvas",
    class: {
      stale: _vm.stale
    },
    attrs: {
      "id": "qrcode_canvas"
    },
    on: {
      "click": _vm.refresh
    }
  }) : _c('div', [_c('img', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "src": require("../../assets/noQrcode.png"),
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "status"
  }, [_vm.activeStatus !== 'UN_SCAN' ? _c('Icon', {
    staticClass: "icon",
    style: {
      color: _vm.activeStatus === 'SCAN_CANCEL' ? '#990033' : '#28c128'
    },
    attrs: {
      "size": "20",
      "type": _vm.icon_check
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.status[_vm.activeStatus]))], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };